import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { usePrivateRoute } from './../../hooks/usePrivateRoute';
import { getMundialGroups } from '../../redux/actions/groups.actions';
import { getMundialBrackets } from '../../redux/actions/matches.actions';
import { MatchesMainContainer } from './components/MatchesMainContainer';
import FullScreenModal from 'components/FullScreenModal';
import './style.scss';

export const MatchesView = () => {
  const [showFullScreen, setShowFullScreen] = useState(false);
  const { standings } = useSelector(state => state.Mundial.Groups);
  const { brackets } = useSelector(state => state.Mundial.Matches);
  const { match_detail_lineup_zoom_img: zoomImg } = useSelector(
    state => state.asset,
  );
  const dispatch = useDispatch();
  usePrivateRoute();

  useEffect(() => {
    if (standings.length === 0) {
      dispatch(getMundialGroups());
    }

    dispatch(getMundialBrackets());
  }, []);

  return (
    <>
      <div className="matches">
        <div className="matches__zoom" onClick={() => setShowFullScreen(true)}>
          Pantalla completa
          <img src={zoomImg} alt="zoom" />
        </div>
        <MatchesMainContainer standings={standings} brackets={brackets} />
      </div>
      <FullScreenModal
        onClose={() => setShowFullScreen(false)}
        show={showFullScreen}
        classNames={['matches__preview']}
        scrollToEnd
      >
        <MatchesMainContainer standings={standings} brackets={brackets} />
      </FullScreenModal>
    </>
  );
};
